import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  THaisyaGetTukekaeZyutyuHaisyaListReq as THaisyaGetBunkatuZyutyuHaisyaListReq,
  THaisyaGetTukekaeZyutyuHaisyaListRes as THaisyaGetBunkatuZyutyuHaisyaListRes,
  THaisyaKinmubiPostReq,
  THaisyaListGetReq,
  THaisyaListGetRes,
  THaisyaPostTukekaeReq,
  THaisyaPostTukekaeRes,
  THaisyaPutHaisoZyunReq,
  THaisyaPutHaisoZyunRes,
  THaisyaPutMihaisyaReq,
  THaisyaPutMihaisyaRes,
} from "./THaisya"

/**
 * 品名マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class HaisyaService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  getList = async (params: THaisyaListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<THaisyaListGetRes>> =
        await this.getInner(`/order/zyutyuhaisya/calendar`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  getBunkatuZyutyuHaisyaList = async (
    params: THaisyaGetBunkatuZyutyuHaisyaListReq
  ) => {
    try {
      const res: AxiosResponse<
        TApiResponse<THaisyaGetBunkatuZyutyuHaisyaListRes>
      > = await this.putInner(`/order/zyutyuhaisya/bunkatu/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 配送順更新
   * @param id 受注配車ID
   * @param params
   * @returns
   */
  putHaisoZyun = async (
    id: number | string,
    params: THaisyaPutHaisoZyunReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<THaisyaPutHaisoZyunRes>> =
        await this.putInner(`/order/zyutyuhaisya/${id}/haisozyun`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 未配車状態移行
   * @param id 受注配車ID
   * @param params
   * @returns
   */
  putMihaisya = async (id: number | string, params: THaisyaPutMihaisyaReq) => {
    try {
      const res: AxiosResponse<TApiResponse<THaisyaPutMihaisyaRes>> =
        await this.putInner(`/order/zyutyuhaisya/${id}/mihaisya`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 付替処理
   * @param id 受注配車ID
   * @param params
   * @returns
   */
  postRegisterTukekae = async (
    id: number | string,
    params: THaisyaPostTukekaeReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<THaisyaPostTukekaeRes>> =
        await this.postInner(`/order/zyutyuhaisya/${id}/bunkatu`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 勤務区分登録
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  kinmubiPost = async (data: THaisyaKinmubiPostReq) => {
    try {
      // const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
      //   `master/hinmei/`,
      //   data
      // )
      // return res.data
      //TODO:ダミーデータを直接加工
      // dummyData.forEach((乗務員) => {
      //   if (乗務員.乗務員ID !== data.乗務員ID) return
      //   if (乗務員.欠勤リスト == null) {
      //     if (data.勤怠区分 != null) {
      //       乗務員.欠勤リスト = [
      //         {
      //           勤務日: data.勤務日,
      //           勤怠区分: data.勤怠区分,
      //         },
      //       ]
      //     }
      //   } else {
      //     const new欠勤リスト = 乗務員.欠勤リスト.filter((k) => {
      //       return !dayjs(k.勤務日).isSame(dayjs(data.勤務日), "date")
      //     })
      //     if (data.勤怠区分 != null) {
      //       new欠勤リスト.push({
      //         勤務日: data.勤務日,
      //         勤怠区分: data.勤怠区分,
      //       })
      //     }
      //     乗務員.欠勤リスト = [...new欠勤リスト]
      //   }
      // })
      return { data: true } as TApiResponse<boolean>
    } catch (err) {
      throw err
    }
  }

  //   /**
  //    * 単体登録
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   post = async (data: THinmeiRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
  //         `master/hinmei/`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体更新
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   put = async (id: string, data: THinmeiRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
  //         `master/hinmei/${id}`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }
}
